import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { IonicComponentsModule } from '@modules/ionicComponents.modules';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@modules/material.modules';

import { ScrollingModule } from '@angular/cdk/scrolling';
import { PipesComponentModule } from '@modules/pipesComponent.modules';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ResizableDirective, ResizableModule, ResizeHandleDirective, } from 'angular-resizable-element';

import { TranslateModule } from '@ngx-translate/core';

/* Modal Components */
import { ChatAIPopUpModal } from '@components/modal-chat-ai/modal-chat-ai.component';
import { ChartDetailChatAIModal } from '@components/modal-chat-ai-details/modal-chart-detail/modal-chart-detail.component';
import { FullResumeDetailChatAIModal } from '@components/modal-chat-ai-details/modal-full-detail/modal-full-detail.component';
import { ResumeDetailChatAIModal } from '@components/modal-chat-ai-details/modal-resume-detail/modal-resume-detail.component';
import { TableDetailChatAIModal } from '@components/modal-chat-ai-details/modal-table-detail/modal-table-detail.component';

@NgModule({
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        IonicComponentsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
        ScrollingModule,
        PipesComponentModule,
        TranslateModule.forChild(),
        BrowserAnimationsModule,
        DragDropModule,
        ResizableModule,
    ],
    declarations: [
        /* Utils Components */

        /* Modal Components */
        ChatAIPopUpModal,
        ChartDetailChatAIModal,
        FullResumeDetailChatAIModal,
        ResumeDetailChatAIModal,
        TableDetailChatAIModal,
    ],
    exports: [
        /* Utils Components */

        /* Modal Components */
        ChatAIPopUpModal,
        ChartDetailChatAIModal,
        FullResumeDetailChatAIModal,
        ResumeDetailChatAIModal,
        TableDetailChatAIModal,
    ],
})
export class ChatAIPopupComponentsModule { }
